import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import Utils from '../../util';

@Directive({
  selector: '[appValidateInputApp][ngModel]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: InputAppValidatorDirective,
    multi: true
  }]
})
export class InputAppValidatorDirective implements Validator {
  @Output() errorMessageUpdated = new EventEmitter();
  errorMessage?: string;
  errorParams: any;
  customErrorMessage?: string;
  @Input()
  set setCustomErrorMessage(message: string) {
    this.errorMessage = '';
    this.customErrorMessage = message;
    this.errorMessageUpdated.emit();
    if (this.control) {
      if (this.validate(this.control)) {
        setTimeout(() => {
          if (!this.control) return;
          this.control.setErrors({ 'incorrect': true })
        });
      } else {
        this.control.setErrors(null);
      }
    }
  }

  @Output() errorMessageUpdate = new EventEmitter<string>();
  @Output() validationUpdated = new EventEmitter();

  @Input() selectValue: string | null = null;
  @Input() inputChecks: (keyof typeof this.formatChecks)[] = [];
  formatChecks = {
    'number': () => {
      if (!this.control) return;
      if (this.valueExists(this.control.value) &&
        !this.valueExists(Utils.removeCommas(this.control.value)) && this.selectValue === null) {
        this.errorMessage = 'HELPER.INPUT_APP.not_number';
      } else if (this.errorMessage === 'HELPER.INPUT_APP.not_number') {
        this.errorMessage = '';
      }
    },
    '>=0': () => {
      if (!this.control) return;
      if (this.haveValue() && Utils.removeCommas(this.control.value) < 0) {
        this.errorMessage = 'HELPER.INPUT_APP.not_negative';
      } else if (this.errorMessage === 'HELPER.INPUT_APP.not_negative') {
        this.errorMessage = '';
      }
    },
    '>=1': () => {
      if (!this.control) return;
      if (this.haveValue() && Utils.removeCommas(this.control.value) < 1) {
        this.errorMessage = 'HELPER.INPUT_APP.less_than_1';
      } else if (this.errorMessage === 'HELPER.INPUT_APP.less_than_1') {
        this.errorMessage = '';
      }
    },
    '<=100': () => {
      if (!this.control) return;
      if (this.haveValue() && Utils.removeCommas(this.control.value) > 100) {
        this.errorMessage = 'HELPER.INPUT_APP.greater_than_100';
      } else if (this.errorMessage === 'HELPER.INPUT_APP.greater_than_100') {
        this.errorMessage = '';
      }
    },
    'integer': () => {
      if (!this.control) return;
      if (this.haveValue() && !Number.isInteger(Utils.removeCommas(this.control.value)) && this.selectValue === null) {
        this.errorMessage = 'HELPER.INPUT_APP.not_integer';
      } else if (this.errorMessage === 'HELPER.INPUT_APP.not_integer') {
        this.errorMessage = '';
      }
    }
  };

  private control?: UntypedFormControl;

  valueExists(value?: string | number): boolean {
    return Boolean(value || value === 0 || value === '');
  }

  haveValue() {
    return this.valueExists(this.control?.value);
  }

  validate(control: UntypedFormControl) {
    this.control = control;
    let isValid = true;
    const initialErrorMessage = this.errorMessage;
    if (control.value || control.value === 0) { // input is not empty
      for (const check of this.inputChecks) {
        if (this.formatChecks[check]) {
          this.formatChecks[check]();
          // if (this.errorMessage) { break; }
        }
      }
    } else { // input is empty
      this.errorMessage = '';
    }

    if (this.errorMessage) {
      isValid = false;
    }
    // update unit-value app error message
    if (initialErrorMessage !== this.errorMessage) {
      this.errorMessageUpdate.emit(this.errorMessage );
    } else if (initialErrorMessage === this.errorMessage && this.errorMessage !== '') {
      this.errorMessageUpdate.emit(this.errorMessage);
    }
    if (!this.errorMessage && this.customErrorMessage) {
      this.errorMessage = this.customErrorMessage;
      this.errorMessageUpdate.emit(this.errorMessage);
    }

    this.validationUpdated.emit(true);
    return (isValid) ? null : { invalid: true };
  }
}
